import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/paymentManage',
  name: 'payManager',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/paymentManage',
      component: () => import('@/views/operation/paymentManage/payment-manager/index.vue'),
      meta: { title: '支付管理', icon: 'pay-code-two' }
    },
    {
      path: '/operation/paymentManage/paymentManInfo/:id',
      name: 'paymentInfo',
      component: () => import('@/views/operation/paymentManage/payment-message/index.vue'),
      meta: { title: '支付租户信息' }
    }
  ]
}
